import React from "react";
import { useClipboard } from "use-clipboard-hook";
import Button from "@atlaskit/button/new";
import CopyIcon from "@atlaskit/icon/core/copy";


const CopyTextButton = ({ copyText }) => {
  const { copy } = useClipboard({
    copiedDuration: 3000,
    disableClipboardAPI: true,
  });
  return (
    <Button appearance="subtle" onClick={() => copy(copyText)} iconBefore={CopyIcon} />
  );
};
export default CopyTextButton;
